import React from 'react';

import { ESaleDiscountDisplayType } from 'constants/enums';
import { SALE_DISCOUNT_TYPE_OPTIONS } from 'views/Offers/Offer.consts';
import Input from 'components/Input/Input';
import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';
import RichText from 'components/RichText/RichText';

interface ISaleDiscountSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  touched: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (field: string, value: any) => void;
}

export const SaleDiscountSection: React.FC<ISaleDiscountSectionProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue
}): React.ReactElement => {
  return (
    <>
      <RichText
        className="mb-5"
        title="Sale & Discounts"
        description="Enhance your offer by providing greater value at a better price"
      />
      <div className="flex flex-col gap-5 mb-2">
        <div className="grid grid-cols-2 gap-5">
          <Input
            label="First Product Sale"
            descriptionDataTestId="bundleProductSaleValidationTxt"
            name="salePercentage"
            value={values.salePercentage}
            onChange={handleChange}
            onBlur={handleBlur}
            type="number"
            min={0}
            step={0.1}
            leftIcon={
              values?.salePercentageDisplayType ===
              ESaleDiscountDisplayType.PERCENTAGE ? (
                <span>%</span>
              ) : undefined
            }
            leftIconStyles="text-base-foreground text-p-s absolute left-2 top-1/2 -translate-y-1/2"
            state={
              touched.salePercentage && errors.salePercentage
                ? 'error'
                : 'default'
            }
            description={
              touched.salePercentage
                ? errors.salePercentage?.toString()
                : ''
            }
          />
          <InputSelectDropdown
            label="Type"
            dataTestId="productSaleTypeDropDown"
            placeholder="Select Type"
            options={SALE_DISCOUNT_TYPE_OPTIONS}
            defaultSelected={
              SALE_DISCOUNT_TYPE_OPTIONS.find(
                (o) =>
                  o.value ===
                  (values?.salePercentageDisplayType ||
                    ESaleDiscountDisplayType.PERCENTAGE)
              ) || SALE_DISCOUNT_TYPE_OPTIONS[0]
            }
            onOptionChange={(value) =>
              setFieldValue('salePercentageDisplayType', value)
            }
            buttonDataTestId="productSaleTypeDropDown"
          />
        </div>
        {values.price > 0 && (
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="Price Discount"
              dataTestId="bundlePriceDiscountInpt"
              descriptionDataTestId="bundlePriceDiscountValidationTxt"
              name="discount"
              value={values.discount}
              onChange={handleChange}
              onBlur={handleBlur}
              type="number"
              min={0}
              step={0.1}
              leftIcon={
                values?.priceDiscountDisplayType ===
                ESaleDiscountDisplayType.PERCENTAGE ? (
                  <span>%</span>
                ) : undefined
              }
              leftIconStyles="text-base-foreground text-p-s absolute left-2 top-1/2 -translate-y-1/2"
              state={
                touched.discount && errors.discount ? 'error' : 'default'
              }
              description={
                touched.discount ? errors.discount?.toString() : ''
              }
            />
            <InputSelectDropdown
              label="Type"
              dataTestId="priceDiscountTypeDropDown"
              placeholder="Select Type"
              disabled
              options={SALE_DISCOUNT_TYPE_OPTIONS}
              defaultSelected={
                SALE_DISCOUNT_TYPE_OPTIONS.find(
                  (o) =>
                    o.value ===
                    (values?.priceDiscountDisplayType ||
                      ESaleDiscountDisplayType.PERCENTAGE)
                ) || SALE_DISCOUNT_TYPE_OPTIONS[0]
              }
              onOptionChange={(value) =>
                setFieldValue('priceDiscountDisplayType', value)
              }
              buttonDataTestId="priceDiscountTypeDropDown"
            />
          </div>
        )}
      </div>
    </>
  );
};
